import MarketplaceReviewLink from './marketplace-review-link';
import GraphQlMarketplaceReviewLink from './graphql-review-link';
import { LINK_TYPES, TRK_PRODUCT_LOCATION } from './constants';
export { GraphQlMarketplaceReviewLink, LINK_TYPES, TRK_PRODUCT_LOCATION };
export default MarketplaceReviewLink;